import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DataRoomShareableLink } from 'models/ShareableLink';
import useGetAnalytics from './useGetAnalytics';
import SecureLinkAnalyticsHeader from './components/SecureLinkAnalyticsHeader';
import SecureLinkEmpty from './components/SecureLinkEmpty';
import { getIsArrayEmpty } from 'utils';
import SecureLinkMembers from './components/SecureLinkMembers';

import './SecureLinkAnalytics.styles.scss';

type SecureLinkAnalyticsProps = {
  className?: string;
  link: DataRoomShareableLink;
};

const SecureLinkAnalytics: React.FC<SecureLinkAnalyticsProps> = (props) => {
  const { className, link } = props;

  const classes = classNames('secure-link-analytics', className);

  const { _id, name } = link || {};

  const { t } = useTranslation();

  const { analytics, isLoading } = useGetAnalytics(_id);

  const isEmpty = !isLoading && getIsArrayEmpty(analytics?.members);

  return (
    <div className={classes}>
      <p>{t('secureLinkAnalytics', { secureLink: name })}</p>
      <p>{t('secureLinkAnalyticsDescription')}</p>

      <SecureLinkAnalyticsHeader {...analytics} isLoading={isLoading} />

      {isEmpty ? (
        <SecureLinkEmpty link={link} />
      ) : (
        <SecureLinkMembers members={analytics?.members} isLoading={isLoading} />
      )}
    </div>
  );
};

export default SecureLinkAnalytics;
